import { Entity } from '@/interfaces'
import model from './model'
import repository from './repository'

const bargainTierEntity: Entity = {
  model: model,
  repository: repository,
}

export default bargainTierEntity
